module.exports = __webpack_public_path__ + "assets/a7986b51ce60795b4e585fa97dcbd04f.svg";